import { render } from "./ObrasTpServicosTabPage.vue?vue&type=template&id=6af3b166"
import script from "./ObrasTpServicosTabPage.vue?vue&type=script&lang=js"
export * from "./ObrasTpServicosTabPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__